<template>
    <div class="w-full h-[57.8125vw] relative overflow-hidden class-above">
        <img src="../../assets/img/Desktop/TopIdlePowers/5.webp" alt="" class="sky-back w-full h-auto absolute top-0 left-0 translate-y-[-18.9vw]">
        <img src="../../assets/img/Desktop/TopIdlePowers/6.webp" alt="" class="castle w-full h-auto absolute top-[4.167vw]">
        <img src="../../assets/img/Desktop/TopIdlePowers/3.webp" alt="" class="road w-full h-auto absolute top-[6vw]">
        <img src="../../assets/img/Desktop/TopIdlePowers/2.webp" alt="" class="dust-1 w-full h-auto absolute top-[3.9vw]">
        <img src="../../assets/img/Desktop/TopIdlePowers/4.webp" alt="" class="dust-2 w-[72.8125vw] h-auto absolute top-[31.5625vw] left-0">
        <img src="../../assets/img/Desktop/TopIdlePowers/1.webp" alt="" class="smoke w-full h-auto absolute top-[32.5vw]">

        <!-- Layer transparent -->
        <div class="absolute top-0 left-0 w-full h-[9.375vw] bg-gradient-to-b from-[#171717] to-transparent"></div>

        <!-- Combo text -->
        <div class="absolute top-[29.0625vw] left-[8.5vw] flex flex-col items-start">
            <p class="font-emeritus text-[4.17vw] text-gradient [text-shadow:0.2vw_0.2vw_#00000025]">TOP IDLE POWERS</p>
            <p class="font-league text-[1.35vw] text-white font-medium">Ancient forces awaken! These legendary idle powers channel pure energy to grow your empire while you rest.</p>
            <p class="font-league text--[0.83vw] text-white font-normal">Unlock powerful passive abilities that keep working even when you're offline. Boost your progress without lifting a finger!</p>
            <img src="../../assets/img/Desktop/Home/EnterAerthospng.webp" alt="" class="w-[7.4vw] mt-[0.4vw] hover:cursor-pointer hover:opacity-80 duration-500 transition-all ease-in-out" @click="openWebLink('https://play.idle-glory.io/')">
        </div>
    </div>
</template>

<script setup>
function openWebLink(url) {
  setTimeout(() => {
    window.open(url, "_blank");
  }, 300);
}
</script>

<style scoped>
.font-emeritus {
  font-family: "Emeritus", sans-serif;
}

.font-league {
  font-family: "LeagueSpartan", sans-serif;
}

.radial-layer-shadow {
  background: radial-gradient(circle, #171717 0%, transparent 100%);
  filter: blur(1vw);
}

.text-gradient {
  background: linear-gradient(to bottom, 
    #FDFDFA 0%, 
    #FDFDFA 41%,
    #FFD446 55%, 
    #FFF2B7 100% 
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.sky-back {
  transform: translateY(-18.9vw);
  scale: 1.05;
  transition: transform 0.8s ease-in-out;
}

.class-above:hover .sky-back {
  transform: translateY(-25vw);
}

.castle {
  transform: translateY(-0);
  transition: transform 0.8s ease-in-out;
}

.class-above:hover .castle {
  transform: translateY(-3vw);
}

.road {
  transform: translateY(-0);
  transition: transform 1.3s ease-in-out;
}

.class-above:hover .road {
  transform: translateY(10vw);
}

.dust-1 {
  transform: scale(1) translateX(0);
  transition: transform 1.3s ease-in-out;
}

.class-above:hover .dust-1 {
  transform: scale(1.2) translateX(-5vw);
}

.dust-2 {
  transform: scale(1) translateX(0);
  transition: transform 1.3s ease-in-out;
}

.class-above:hover .dust-2 {
  transform: scale(1.2) translateX(5vw);
}

.smoke {
  transform: scale(1) translateY(0);
  transition: transform 1.3s ease-in-out;
}

.class-above:hover .smoke {
  transform: scale(1) translateY(-5vw);
}
</style>